module.exports = __webpack_public_path__ + "img/G2.8cb919fa.jpg";